export default function({ title, message }) {
  alert(`${title}\n${message}`)
}
